/* eslint-disable */
import React from 'react'
import { scaleLinear } from 'd3-scale'
import { range } from 'd3-array'
import { line } from 'd3-shape'

import filter from 'lodash/filter'
import groupBy from 'lodash/groupBy'
import * as d3Color from 'd3-color'
import { RemoveBadPitchPoints } from '../../Utilities/RemoveBadPoints'
import Color from '../../Utilities/Colors/ColorMap'
import Tooltip from '../../Tooltip/Tooltip'
import TooltipHtml from '../../Tooltip/Html/SingleEvent'
import Legend from '../../Legend/Legend'

import setTextColorWithBackground from '../../Utilities/Colors/TextColorBasedOnBackground'

export default function Pitches({ settings, chartOptions = {} }) {
    let pitchData = settings.data

    const groupData = chartOptions.groupBy
    // Field to bind
    const yField = chartOptions.yField || 'releaseSpeed'
    // Unit (MPH, RPM) for Label
    const unit = chartOptions.unit || 'MPH'
    // Used to set the range between horizontal lines (10 MPH)
    const yRangeSize = chartOptions.yRange || 10

    if (chartOptions.autoFilterBadPoints) {
        pitchData = filter(
            pitchData,
            (d) =>
                d[yField] &&
                d[yField] !== null &&
                d[yField] !== '' &&
                Number(d[yField]) > 0
        )
    }

    const groupedData = groupBy(pitchData, (d) => d[groupData])

    // Default x, y MPH
    let xDomain = [0, 1]
    let yDomain = [60, 105]

    if (chartOptions.yDomain) {
        yDomain = chartOptions.yDomain
    }

    let max = 1
    const pitchTypes = []
    if (chartOptions.xDomain) {
        xDomain = chartOptions.xDomain
    } else {
        for (const type in groupedData) {
            if (groupedData[type].length > max) {
                max = groupedData[type].length
            }
            pitchTypes.push(groupedData[type])
        }
        xDomain = [1, max]
    }

    const path = line()
        .x((d, i) => x(i + 1))
        .y((d) => y(d[yField]))

    const x = scaleLinear().range([0, settings.vizWidth]).domain(xDomain)
    const y = scaleLinear().range([settings.vizHeight, 0]).domain(yDomain)
    let yRange
    let hideTopLegendValue = false
    if (yDomain[0] < yDomain[1]) {
        yRange = range(yDomain[0], yDomain[1], yRangeSize)
    } else {
        hideTopLegendValue = true
        yRange = range(yDomain[1], yDomain[0], yRangeSize)
    }
    const xRangeUgly = range(xDomain[0], xDomain[1], xDomain[1] / 5)
    const xScale = scaleLinear().domain(xRangeUgly).nice()
    const xRange = xScale.ticks(5)

    function handleMouseOver(event, tip) {
        Tooltip(event, settings, tip)
    }

    function handleMouseOut(event) {
        Tooltip(event, settings)
    }

    const radiusSize = 2

    const xContainerAdjustment = settings.shape === 'snap' ? -30 : -20
    const yContainerAdjustment = settings.shape === 'snap' ? -50 : 10

    return (
        <>
            <g
                transform={`translate(${xContainerAdjustment}, ${yContainerAdjustment})`}
                id="lineGraph"
            >
                <line
                    x1={x(xDomain[0])}
                    x2={x(xDomain[1])}
                    y1={y(yDomain[0])}
                    y2={y(yDomain[0])}
                    stroke="#eeeeee"
                />
                <line
                    x1={x(1)}
                    x2={x(1)}
                    y1={y(yDomain[0])}
                    y2={y(yDomain[1])}
                    stroke="#eeeeee"
                />

                <text
                    x={settings.vizWidth / 2}
                    y={y(yDomain[0])}
                    dy={30}
                    textAnchor="middle"
                >
                    Pitches
                </text>
                {xRange.map((label, i) => (
                    <React.Fragment key={`xLabelLineFrag_${i + 1}`}>
                        <line
                            key={`xLabelLine_${i + 1}`}
                            id={`xLabelLine_${i + 1}`}
                            x1={x(
                                Number(label) == 0 ? Number(label) + 1 : label
                            )}
                            x2={x(
                                Number(label) == 0 ? Number(label) + 1 : label
                            )}
                            y1={y(yDomain[0])}
                            y2={y(yDomain[1])}
                            stroke="#f0f0f0"
                        />
                        <text
                            key={`xLabelText_${i}`}
                            id={`xLabelText_${i}`}
                            x={x(label)}
                            y={y(yDomain[0])}
                            dy={14}
                            className="line-graph-x-axis-label"
                            textAnchor="middle"
                        >
                            {i === xRange.length
                                ? ``
                                : label != 0
                                ? Math.abs(label)
                                : null}
                        </text>
                    </React.Fragment>
                ))}
                {yRange.map((label, i) => (
                    <React.Fragment key={`yLabelLineFrag_${i + 1}`}>
                        <line
                            key={`yLabelLine_${i}`}
                            x1={x(xDomain[0])}
                            x2={x(xDomain[1])}
                            y1={y(label)}
                            y2={y(label)}
                            stroke="#f0f0f0"
                        />
                        <text
                            key={`yLabelText_${i}`}
                            x={x(xDomain[0]) / 1.1}
                            y={y(label)}
                            dx={-5}
                            className="line-graph-y-axis-label"
                        >
                            {i === 0 && hideTopLegendValue
                                ? ``
                                : label != 0
                                ? `${label} ${unit}`
                                : `${label} ${unit}`}
                        </text>
                    </React.Fragment>
                ))}
                {pitchTypes.map((pitches, z) => (
                    <path
                        key={`linePitch_${z}`}
                        d={path(pitches)}
                        fill="none"
                        strokeWidth={2}
                        stroke={Color(
                            chartOptions.legendType,
                            pitches[0][chartOptions.legendType]
                        )}
                    />
                ))}
                {pitchTypes.map((pitches, z) => {
                    {
                        return pitches.map((d, i) => (
                            <g
                                key={`g_rp_key_${i}`}
                                transform={`translate(${x(i + 1)},${y(
                                    Number(d[yField])
                                )})`}
                                style={{ cursor: 'pointer' }}
                                onMouseOver={(event) => {
                                    const html = d.tooltip
                                    if (html) {
                                        handleMouseOver(event, html)
                                    }
                                }}
                                onMouseOut={(event) => {
                                    handleMouseOut(event, d)
                                }}
                                onClick={() => {
                                    if (d.videoUrl) {
                                        window.open(d.videoUrl)
                                    }
                                }}
                            >
                                <circle
                                    key={`rp_${i}`}
                                    r={radiusSize / settings.vizScale}
                                    opacity={chartOptions.opacity}
                                    fill={Color(
                                        chartOptions.legendType,
                                        d[chartOptions.legendType]
                                    )}
                                    stroke="black"
                                />
                                {chartOptions.labelPitches ? (
                                    <text
                                        className="pitch-label"
                                        key={`rp_text_key_${i}`}
                                        id={`text_${i}`}
                                        textAnchor="middle"
                                        dy={4}
                                        fill={setTextColorWithBackground(
                                            d3Color.color(
                                                Color(
                                                    chartOptions.legendType,
                                                    d[chartOptions.legendType]
                                                )
                                            )
                                        )}
                                    >
                                        {i + 1}
                                    </text>
                                ) : null}
                            </g>
                        ))
                    }
                })}
            </g>

            {chartOptions.legend ? (
                <Legend settings={settings} type={chartOptions.legendType} />
            ) : null}
        </>
    )
}
